"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Dydd Gwener",
    "MONDAY": "Dydd Llun",
    "SATURDAY": "Dydd Sadwrn",
    "SUNDAY": "Dydd Sul",
    "THURSDAY": "Dydd Iau",
    "TUESDAY": "Dydd Mawrth",
    "WEDNESDAY": "Dydd Mercher",
    "and": "a",
    "day_few": "dyddiau",
    "day_many": "dyddiau",
    "day_one": "Dydd",
    "day_other": "dyddiau",
    "day_plural": "dyddiau",
    "day_two": "dyddiau",
    "day_zero": "dyddiau",
    "freeOfCharge": "Rhad ac Am Ddim",
    "hour_one": "awr",
    "hour_one_plural": "oriau",
    "hour_other": "oriau",
    "minute_few": "munud",
    "minute_many": "munud",
    "minute_one": "munud",
    "minute_other": "munudau",
    "minute_two": "munud",
    "minute_zero": "munud",
    "ocpiRestrictionsAfterDuration": "Ar ôl {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Rhwng {{minDuration}} a {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "{{maxDuration}} cyntaf",
    "ocpiRestrictionsKwhAbove": "Pan fydd defnydd ynni yn uwch na {{ minKwh}}",
    "ocpiRestrictionsKwhBetween": "Pan fydd defnydd ynni rhwng {{ minKwh}} a {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Pan fydd defnydd ynni yn llai na {{maxKwh}}",
    "session": "sesiwn",
    "theDay_few": "Dydd",
    "theDay_many": "Dydd",
    "theDay_one": "Dydd",
    "theDay_other": "dyddiau",
    "theDay_two": "Dydd",
    "theDay_zero": "Dydd",
    "theHour_few": "awr",
    "theHour_many": "awr",
    "theHour_one": "awr",
    "theHour_other": "oriau",
    "theHour_two": "awr",
    "theHour_zero": "awr",
    "theMinute_few": "munud",
    "theMinute_many": "munud",
    "theMinute_one": "munud",
    "theMinute_other": "munudau",
    "theMinute_two": "munud",
    "theMinute_zero": "munud"
};
